module.exports = __webpack_public_path__ + "img/组 134@2x.bb30214a.png";